import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class StatisticsService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = createPrefix('/statistics', {
      member: [
        '/member',
        {
          beneficiaries: '/beneficiaries',
        },
      ],

      matches: [
        '/matches',
        {
          nba: '/nba',
        },
      ],
      beneficiary: (id) => `/inwins/beneficiary/${id}`,
    })
  }

  static create() {
    return new StatisticsService()
  }

  async queryBeneficiaries(params) {
    const servicePath = this.endpoints.member.beneficiaries()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getNBAMatchesStatistics(seasonYear) {
    const servicePath = this.endpoints.matches.nba()
    const { data } = await axios.get(servicePath, { params: { seasonYear } })
    return data
  }

  async getBeneficiaryInwinStatistics(beneficiaryId, timeFrame) {
    if (!StatisticsService.TIME_FRAMES.includes(timeFrame)) {
      throw new Error(`Time frame paramerter is wrong: [${timeFrame}]`)
    }

    const servicePath = this.endpoints.beneficiary(beneficiaryId)
    const { data } = await axios.get(servicePath, { params: { timeFrame } })
    return data
  }
}
